import DBOperations from "src/utils/dbOperations";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.TAGS_TABLE;

async function createNewTag(data) {
  try {
    return await DBOperations.insertData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateTag(data) {
  try {
    return await DBOperations.updateData(tableName, data);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function deleteTag(id) {
  try {
    let data = {
      id,
      is_deleted: true
    };
    let _res = await DBOperations.updateData(tableName, data);
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function recoverTag(id) {
  try {
    let data = {
      id,
      is_deleted: false
    };
    let _res = await DBOperations.updateData(tableName, data);
    return { data, ..._res };
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getTags(config) {
  try {
    return await DBOperations.fetchData(
      tableName,
      config.fetchDeleted,
      config.searchTxt,
      config.sortField,
      config.sortOrder,
      config.page,
      config.rows,
      config.fetchAll
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  createNewTag,
  updateTag,
  getTags,
  deleteTag,
  recoverTag
};
